import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { PROPOSAL_KEYS } from "~/api/cache"

import type { PowurOsPricingDto } from "../dto/proposal.dto"
import { ProposalService } from "../services/proposal.service"

const proposalService = new ProposalService()

function useUpdateProposalTotalCost(): UseMutationResult<
  PowurOsPricingDto,
  unknown,
  {
    id: string
    totalCost: number
  }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, totalCost }): Promise<PowurOsPricingDto> => {
      return proposalService.fetchProposalPricingSummaryByTotalCost(
        id,
        totalCost,
      )
    },
    onSuccess: (data, variables) => {
      // Update the cache with the server response
      queryClient.setQueryData<PowurOsPricingDto>(
        PROPOSAL_KEYS.pricing(variables.id),
        data,
      )

      return { data }
    },
  })
}

export default useUpdateProposalTotalCost
